<div class="container mr-tp-2">
  <div class="business-banner-top post-box-shadow">
    <div class="business-banner">
      <div class="banner-shadow"></div>
      <img class="banner-img" *ngIf="response?.bannerImage==null && response?.bannerImage==undefined"
        [ngStyle]="{ 'background-image': 'url(assets/images/networkbanner.png)' }" />
      <img class="banner-img" *ngIf="response?.bannerImage!=null && response?.bannerImage!=undefined"
        [ngStyle]="{ 'background-image': 'url( '+url+response?.bannerImage+')' }" />
      <div class="banner-overlay">
        <div class="banner-edit" *ngIf="ownerFlag">
          <input type="file" accept=".jpg, .jpeg, .png" #myFileInput (change)="fileChangeEvent($event, template)"
            (click)="myFileInput.value = null" />
          <div class="image-upload"></div>
          <ng-icon name="tablerCamera" aria-hidden="true"></ng-icon>
        </div>
        <div class="banner-profile-image">
          <img *ngIf="response?.logo==null && response?.logo==undefined" src="assets/icon/icons8-share-400.png" alt=""
            srcset="" />
          <img *ngIf="response?.logo!=null && response?.logo!=undefined" src="{{url+response?.logo}}" alt=""
            srcset="" />
        </div>
      </div>
    </div>
  </div>

  <div class="hpanel scroll-header business-banner-top">
    <div class="panel-body">
      <div class="col-md-8 d-flex629">
        <h5 class="bus-hov business-name fw-bold-1" [routerLink]="['/landingPage/team']">Workspace:</h5>
        <div class="business-name break-word ellipse7 rem-1" data-toggle="tooltip" data-placement="top"
          title="{{response?.teamName}}">
          {{response?.teamName }}
          <span *ngIf="response?.memberCnt!=0 && response?.teamName" class="opi">|</span>
          <span class="lkio" (click)="menuclick('members')"><span>
              {{response?.memberCnt}}</span> Member<span *ngIf="response?.memberCnt>1">s </span></span>
        </div>
      </div>
      <div class="col-md-4">
        <div class="row" style="float: right;">
          <div class="col-md-12">
            <button type="button" class="btn primary-btn " style="margin-right:10px;" (click)="mgsBtn()">
              Message</button>
            <button type="button" class="btn primary-btn margin-right-20" *ngIf="ownerFlag"
              (click)="deletenet('delete')"> Deactivate Workspace</button>
            <button type="button" class="btn primary-btn margin-right-20" *ngIf="memberflag"
              (click)="deletenet('leave')"> Leave Workspace</button>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="network-page-layout" style="position: relative;">
    <div class="network-menu">
      <app-team-side-bar-nav [userDataInput]="pathdata.menu"></app-team-side-bar-nav>
    </div>
    <div class="feed-widget-combo">
      <router-outlet></router-outlet>
    </div>
  </div>
</div>
<ng-template #template>
  <div class="modal-content">
    <div class="common-header-flex">
      <div>Workspace Banner Image</div>
      <button>
        <span (click)="closePhoto()" class="common-close">&times;</span>
      </button>
    </div>
    <hr style="margin: 0px !important; padding: 0px !important">
    <div class="modal-body">
      <image-cropper [imageChangedEvent]="imageChangedEvent" [maintainAspectRatio]="true" [aspectRatio]="4.5 / 1"
        format="jpeg" (imageCropped)="imageCropped($event)"></image-cropper>
    </div>

    <div class="custom-panel-footer">
      <div class="panel-footer">
        <div class="footer-flex">
          <button class="btn btn-default" (click)="closePhoto()">Cancel</button>
          <button class="btn  btn-primary " (click)="imageLoaded()">Apply</button>
        </div>
      </div>
    </div>

  </div>
</ng-template>